import React, { useEffect } from 'react';
import { Input, Button, Form } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import AuthLayout from './AuthLayout';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  const { authentication, auth, clearAuthMessage, setReturnUrl } = usePersistedStore();
  const general = useGeneralStore();

  const loading = auth.loading;
  const message = auth.message;
  const mobileNumber = auth.mobile;

  useEffect(() => {
    // Store returnUrl from URL params
    const searchParams = new URLSearchParams(location.search);
    const returnUrlParam = searchParams.get('returnUrl');
    if (returnUrlParam) {
      setReturnUrl(returnUrlParam);
    }

    // Reset any previous auth state
    clearAuthMessage();
  }, [location.search, setReturnUrl, clearAuthMessage]);

  function onFinish(values) {
    const mobileNumber = values.username; // Remove non-digits
    authentication({ MobileNumber: mobileNumber })
      .then((data) => {
        if (data) {
          // Check if user has password and is registered
          if (data.HasPassword && data.Registered) {
            // Show both options - let user choose
            navigate('/auth/code' + location.search);
          } else {
            // Only OTP available
            navigate('/auth/code' + location.search);
          }
        }
      });
  }

  function onFinishFailed(errorInfo) {
    form.scrollToField(errorInfo.errorFields[0].name, {
      scroll: {
        offsetTop: 65,
      },
    });
  }

  const onlyNumber = (e) => {
    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
      e.preventDefault();
    }
  };

  return (
    <AuthLayout title="ورود / ثبت نام" subtitle="نام کاربری خود را وارد کنید">
      <Form
        className="form-horizontal"
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{ username: mobileNumber }}
      >
        <div className="form-group">
          <Form.Item
            label="نام کاربری"
            name="username"
            validateStatus={message ? 'error' : 'validating'}
            help={message}
            rules={[
              { required: true, message: "نام کاربری اجباری است" },
              // {
              //   pattern: /^09\d{9}$/,
              //   message: "شماره موبایل باید 11 رقم و با 09 شروع شود"
              // }
            ]}
          >
            <Input
              className="form-control form-input"
              placeholder="نام کاربری را وارد کنید"
              type="text"
              // onKeyPress={onlyNumber}
              onChange={() => message && clearAuthMessage()}
            // maxLength={11}
            />
          </Form.Item>
        </div>
        <div className="mt-3">
          <Button
            type="primary"
            loading={loading}
            className="btn btn-block waves-effect waves-light"
            htmlType="submit"
            block
          >
            ادامه
          </Button>
        </div>
      </Form>
    </AuthLayout>
  );
}
